// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@keyframes shimmer-loading--aaU4R{0%{background-position:200% 0}100%{background-position:-200% 0}}.fullscreen-toggle--PLvhX{position:absolute;right:50px;bottom:46px;opacity:1;z-index:199}.fullscreen-toggle--PLvhX i{color:#d7dae4;font-size:30px}.fullscreen-toggle--PLvhX:hover{opacity:.8}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fullscreen-toggle": "fullscreen-toggle--PLvhX",
	"shimmer-loading": "shimmer-loading--aaU4R"
};
export default ___CSS_LOADER_EXPORT___;
